import FadeIn from "@ui/FadeIn";
import Default from "@layouts/Default";
import viewStates from "@data/viewStates";
import type { FC } from "react";

const ErrorView: FC = () => {
  return (
    <FadeIn>
      <Default
        Icon={viewStates.error.Icon}
        title={viewStates.error.title}
        body={viewStates.error.body}
        showInput={viewStates.error.showInput}
        showLostCode={viewStates.error.showLostCode}
        showGoHome={viewStates.error.showGoHome}
        showTroubleshoot={viewStates.default.showTroubleshoot}
      />
    </FadeIn>
  );
};

export default ErrorView;
